import { ProcessButton } from "@/core/shared";

export default (withComponents = true, withMethods = true) => {
  const components = {
    ProcessButton
  };

  const data = () => ({
    btnStatus: {
      success: false,
      loading: false,
      error: false
    }
  });

  const methods = {
    resetStatus() {
      this.btnStatus.loading = false;
      this.btnStatus.success = false;
      this.btnStatus.error = false;
    },
    activeLoading() {
      this.resetStatus();
      this.btnStatus.loading = true;
    },
    activeError() {
      this.resetStatus();
      this.btnStatus.error = true;
    },
    activeSuccess() {
      this.resetStatus();
      this.btnStatus.success = true;
    }
  };

  const output = {
    data
  };

  if (withComponents) {
    output.components = components;
  }

  if (withMethods) {
    output.methods = methods;
  }

  return output;
};
